import { createReducer, createActions } from 'reduxsauce';
import update from 'immutability-helper';
import type { RecalculateTransitTime } from 'contracts/TransitTimes';

const { Types, Creators } = createActions(
  {
    request: ['invoiceKey', 'onSuccess', 'onFailure'],
    success: ['data'],
    failure: ['errorMessage'],
    softReset: [],
    reset: [],
  },
  {
    prefix: 'RECALCULATE_TRANSITTIME_',
  }
);

export interface RecalculateTransitTimeState {
  data: RecalculateTransitTime | null;
  loading: boolean;
  errorMessage: string | null;
}

export interface RecalculateTransitTimeRequestAction {
  invoiceKey: number;
  onSuccess?: () => void;
  onFailure?: () => void;
}

interface SuccessAction {
  data: RecalculateTransitTime;
}

interface FailureAction {
  errorMessage: string;
}

const INITIAL_STATE: RecalculateTransitTimeState = {
  data: null,
  loading: false,
  errorMessage: null,
};

const request = (state: RecalculateTransitTimeState) =>
  update(state, {
    loading: { $set: true },
    errorMessage: { $set: null },
  });

const success = (state: RecalculateTransitTimeState, action: SuccessAction) =>
  update(state, {
    loading: { $set: false },
    data: { $set: action.data },
  });

const failure = (state: RecalculateTransitTimeState, action: FailureAction) =>
  update(state, {
    loading: { $set: false },
    errorMessage: { $set: action.errorMessage },
  });

const softReset = (state: RecalculateTransitTimeState) =>
  update(state, {
    loading: { $set: false },
  });

const reset = () => INITIAL_STATE;

export const recalculateTransitTime = createReducer(INITIAL_STATE, {
  [Types.REQUEST]: request,
  [Types.SUCCESS]: success,
  [Types.FAILURE]: failure,
  [Types.SOFT_RESET]: softReset,
  [Types.RESET]: reset,
});

export const RecalculateTransitTimeTypes = Types;
export const RecalculateTransitTimeActions = Creators;
